module.exports = function(options) {
  //
  //   Private Vars
  //
  //////////////////////////////////////////////////////////////////////

  const self = {
  };


  //
  //   Public Vars
  //
  //////////////////////////////////////////////////////////////////////

  self.settings = $.extend({
    $container: $('.js-remove-digits'),
    textSelector: ''
  }, options);


  //
  //   Private Methods
  //
  //////////////////////////////////////////////////////////////////////

  const _init = function() {
    if (self.settings.$container.length === 0 || self.settings.textSelector.length === 0) return;

    self.regex = /\s([0-9][0-9]{0,2})/g;

    _stripText();
    _addEventListener();
  };

  const _addEventListener = function() {
    self.settings.$container.on('change', _stripText);
  };

  const _stripText = function() {

    $(self.settings.textSelector).each(function(i, el) {
      const string = $(el).text();

      if (string.match(self.regex)) {
        const newString = string.replace(self.regex, '');
        $(el).text(newString);
      }
    });
  };

  //
  //   Initialize
  //
  //////////////////////////////////////////////////////////////////////

  _init();

  // Return the Object
  return self;
}
